<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Login</h4>
  <button type="button" class="close" aria-label="Close" (click)="CloseLoginModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-container *ngIf="(ucdService.User | async) as user">
    <ngb-alert *ngIf="user.LoginError == 'LoginByCookie failed'" type="info" [dismissible]="false">Your
      connection was interrupted. Just checking you're still here!</ngb-alert>
  </ng-container>
  <form class="mx-5" #loginForm="ngForm" (ngSubmit)="submitLogin(loginForm)">
    <div class="form-group">
      <label for="user_email">Email address</label>
      <input type="email" class="form-control" name="user_email" placeholder="me@mysite.com" required ngModel
        ngbAutoFocus>
    </div>
    <div class="form-group">
      <label for="user_password">Password</label>
      <input type="password" class="form-control" name="user_password" required ngModel>
    </div>
    <div class="form-group d-flex justify-content-center">
      <button type="submit" class="btn btn-primary"
        [disabled]='loginInProgress'>{{loginInProgress ? 'Logging in...' : 'Login'}}</button>
    </div>
    <ngb-alert *ngIf="!loginInProgress && loginError" [type]="'warning'" [dismissible]="false">{{loginError}}</ngb-alert>
    <div class="form-group text-center">
      <a class="d-inline-block mb-3" href="https://www.abmp.com/signup?destination=learn">New user? Create
        an account</a>
      <br />
      <a class="text-secondary" href="https://www.abmp.com/user/password" target="_blank">Forgot password?</a>
    </div>
  </form>
</div>
